import { useTranslation } from '@multaqa/i18n'
import { Badge, type BadgeTone } from '@multaqa/ui/components/ui/badge'
import type { InvoicePaymentStatus, InvoicePostingStatus } from './api'

const POSTING_TONES: Record<InvoicePostingStatus, BadgeTone> = {
  draft: 'neutral',
  posted: 'success',
  cancelled: 'neutral',
}

const PAYMENT_TONES: Record<InvoicePaymentStatus, BadgeTone> = {
  unpaid: 'warning',
  partially_paid: 'warning',
  paid: 'success',
  overdue: 'danger',
}

export function postingStatusTone(status: InvoicePostingStatus): BadgeTone {
  return POSTING_TONES[status]
}

export function InvoicePostingStatusBadge({
  status,
  ...props
}: { status: InvoicePostingStatus } & Record<string, unknown>) {
  return (
    <InvoiceStatusBadge
      tone={POSTING_TONES[status]}
      translationKey={`invoices.postingStatus.${status}`}
      {...props}
    />
  )
}

export function InvoicePaymentStatusBadge({
  status,
  creditNote = false,
  ...props
}: { status: InvoicePaymentStatus; creditNote?: boolean } & Record<string, unknown>) {
  return (
    <InvoiceStatusBadge
      tone={PAYMENT_TONES[status]}
      translationKey={`invoices.paymentStatus.${creditNote ? `creditNote.${status}` : status}`}
      {...props}
    />
  )
}

function InvoiceStatusBadge({
  tone,
  translationKey,
  ...props
}: { tone: BadgeTone; translationKey: string } & Record<string, unknown>) {
  const { t } = useTranslation('accounting')

  return (
    <Badge tone={tone} {...props}>
      {t(translationKey)}
    </Badge>
  )
}
